




































import { Vue, Component, Prop } from "vue-property-decorator";
import colors from "vuetify/es5/util/colors";
import CdkClassification from "@dpa-connect/dpa-connect-classification";
import { computed } from "vue";
import {
  getPriorityFilterRules,
  getKeywordFillterRules,
  getGeoAreaFilterRules
} from "../../store/modules/newsItems/getters";
import CdkImageDetail from "./CdkImageDetail.vue";
import CdkSharing from "@/components/CdkSharing";
import CdkImagePlaceholder from "../SlcNewsItem/ContentRows/CdkImagePlaceholder.vue";
import CdkImage from "../SlcNewsItem/ContentRows/CdkImage.vue";
import CdkImageMetadata from "./CdkImageMetadata.vue";
import CdkGraphicsMetadata from "./CdkGraphicsMetadata.vue";
import { NewsItemDetail } from "./types.d";
import getResidref from "@/utils/remoteMedia";
import useKeywordTracking from "@/composition/useKeywordTracking";
import useShareViaEmail from "../SlcNewsItem/lib/useShareViaEmail";
import usePDFExport from "../SlcNewsItem/lib/usePDFExport";

// @ts-ignore
@Component({
  inject: ["eventBus"],
  setup(props) {
    const { trackKeywordClickEvent } = useKeywordTracking();
    const newsItem = computed(() => props.newsItem);
    // @ts-ignore
    const emailSharing = computed(() => useShareViaEmail(newsItem));
    // @ts-ignore
    const pdfExport = usePDFExport(newsItem);

    return { trackKeywordClickEvent, emailSharing, pdfExport };
  },
  components: {
    CdkSharing,
    CdkImageDetail,
    CdkClassification,
    CdkImagePlaceholder,
    CdkImage,
    CdkImageMetadata,
    CdkGraphicsMetadata
  }
})
export default class CdkImageDetailProvider extends Vue {
  @Prop({
    required: true,
    type: Object,
    default: () => ({})
  })
  newsItem!: NewsItemDetail;

  @Prop({ type: String, required: false })
  imgSrc?: string;

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  showSharingOptions?: Boolean;

  @Prop({
    type: Array,
    required: false,
    default: () => []
  })
  categories?: any[];

  // WIP: Needs adjustment
  get tags(): any[] {
    // @ts-ignore
    const { urgency, subject, keyword } = this.newsItem;

    return [
      ...getPriorityFilterRules(urgency),
      ...this.categoryFilterRules, // Inject resolved categories
      ...this.subjectFilterRules,
      ...getKeywordFillterRules(keyword),
      ...getGeoAreaFilterRules(subject)
    ];
  }

  get isUrgent(): boolean {
    // @ts-ignore
    return this.newsItem.urgency === 1 || this.newsItem.urgency === 2;
  }

  get backgroundColor(): string {
    return this.isUrgent ? colors.red.lighten5 : "#fff";
  }

  /**
   * Forward tag click event to parent scope
   */
  tagClick(payload): void {
    this.$emit("tagClick", payload);
  }

  get imageOrientation(): string {
    // @ts-ignore
    const content = this.newsItem.remoteContent[0];
    if (content && content.layoutOrientation) {
      const arr = content.layoutOrientation.split("/");
      return arr[arr.length - 1];
    }
    return "horizontal";
  }

  get computedDesc(): string {
    // @ts-ignore
    const fetchedDesc = this.newsItem.description;

    if (fetchedDesc[1] && fetchedDesc[1].text) {
      return fetchedDesc[1].text;
    }
    if (fetchedDesc[0] && fetchedDesc[0].text) {
      return fetchedDesc[0].text;
    }
    return "";
  }

  get mappedCategories(): any[] {
    // @ts-ignore
    const categories = this.newsItem.subject.filter(
      ({ type }) => type === "category"
    );
    // @ts-ignore
    const mapped = this.categories.filter(item =>
      categories.some(category => category.uri === item.id)
    );

    return mapped;
  }

  get categoryFilterRules(): any[] {
    return this.mappedCategories.map(({ id, name }) => ({
      type: "FILTER_CATEGORY",
      values: [id],
      text: name
    }));
  }

  /**
   * REVIEW: For now only full text search is supported,
   * in a later stage it could be its own filter rule, e.g.
   * "FILTER_SUBJECT"
   */
  get subjectFilterRules(): any[] {
    // @ts-ignore
    return this.newsItem.subject
      .filter(({ type }) => type === "dpasubject")
      .map(({ name }) => ({
        type: "FILTER_FULLTEXT",
        values: [name],
        text: name
      }));
  }

  /**
   * Returns the residref if present in the remote content array
   */
  get residref(): String {
    // @ts-ignore
    if (this.newsItem.remoteContent.length) {
      // @ts-ignore
      const residref =
        this.newsItem.itemClass === "graphic"
          ? getResidref(this.newsItem.remoteContent, "graphic")
          : this.newsItem.remoteContent[0].residref;
      return residref;
    }
    return "";
  }

  get metadataComponent() {
    const { itemClass } = this.newsItem;
    if (itemClass === "graphic") {
      return CdkGraphicsMetadata;
    }
    return CdkImageMetadata;
  }
}
